export default __webpack_public_path__ + "static/team-2-3bc5321494e7721e0f0b41dd0bbb60c6.png";